export const deleteBase64Info = string =>
  string.replace(/^data:(application|image)\/(png|jpg|jpeg|octet-stream|pdf);base64,/, "");
